export default {
  // ===== Shared: Recharge Management + Order Ledger =====
  'pages.billing.bizVoiceClone': 'Voice clone',
  'pages.billing.bizSim': '4G data top-up',
  'pages.billing.bizVoiceCloneQuota': 'Voice clone quota pack',

  'pages.billing.saved': 'Saved',
  'pages.billing.saveFail': 'Failed to save',
  'pages.billing.deleted': 'Deleted',
  'pages.billing.detailLoadFail': 'Failed to load details',
  'pages.billing.retryTriggered': 'Retry triggered',
  'pages.billing.wechatRefundStarted': 'WeChat original-route refund initiated',

  'pages.billing.colCode': 'Code',
  'pages.billing.colName': 'Name',
  'pages.billing.colEnabled': 'Enabled',
  'pages.billing.colSort': 'Sort',
  'pages.billing.colActions': 'Actions',
  'pages.billing.colProvider': 'Provider',
  'pages.billing.colPackageName': 'Plan name',
  'pages.billing.colPlatformCode': 'Platform code',
  'pages.billing.colUseTypeField': 'Use type field',
  'pages.billing.colUserPrice': 'User price (CNY)',
  'pages.billing.colCostPrice': 'Cost price (CNY)',
  'pages.billing.colOrderNo': 'Order no.',
  'pages.billing.colType': 'Type',
  'pages.billing.colBizType': 'Business type',
  'pages.billing.colUserId': 'User ID',
  'pages.billing.colDeviceId': 'Device ID',
  'pages.billing.colAmount': 'Amount (CNY)',
  'pages.billing.colFee': 'Fee (CNY)',
  'pages.billing.colStatus': 'Status',
  'pages.billing.colRefundStatus': 'Refund status',
  'pages.billing.colCreatedAt': 'Created at',
  'pages.billing.colCompletedAt': 'Completed at',
  'pages.billing.colPayChannel': 'Pay channel',

  'pages.billing.yes': 'Yes',
  'pages.billing.no': 'No',
  'pages.billing.edit': 'Edit',
  'pages.billing.delete': 'Delete',
  'pages.billing.confirmDelete': 'Delete for sure?',
  'pages.billing.detail': 'Details',
  'pages.billing.retryRecharge': 'Retry top-up',
  'pages.billing.wechatRefund': 'WeChat refund',
  'pages.billing.usedNoRefund': 'Used quota is non-refundable',
  'pages.billing.retryConfirm':
    'Re-initiate IoT top-up for this order? (Orders already sent to the platform cannot be retried.)',
  'pages.billing.wechatRefundConfirm':
    'Initiate a full WeChat original-route refund? The arrival time follows WeChat.',

  'pages.billing.tabProviders': 'SIM providers',
  'pages.billing.tabPackages': 'Top-up plans',
  'pages.billing.tabOrders': 'Top-up orders',
  'pages.billing.newProvider': 'New provider',
  'pages.billing.newPackage': 'New plan',
  'pages.billing.refresh': 'Refresh',
  'pages.billing.query': 'Search',
  'pages.billing.filterOrderType': 'Order type',
  'pages.billing.all': 'All',
  'pages.billing.optional': 'Optional',
  'pages.billing.orderNoFuzzy': 'Order no. (fuzzy)',

  'pages.billing.statusPending': 'Unpaid',
  'pages.billing.statusPaid': 'Paid',
  'pages.billing.statusRecharging': 'Recharging',
  'pages.billing.statusDone': 'Completed',
  'pages.billing.statusFailed': 'Failed',
  'pages.billing.statusCancelled': 'Cancelled',

  'pages.billing.rechargeManageTitle': 'SIM Data Top-up Management',
  'pages.billing.orderLedgerTitle': 'Order Ledger',
  'pages.billing.editProvider': 'Edit provider',
  'pages.billing.uniqueCode': 'Unique code',
  'pages.billing.required': 'Required',
  'pages.billing.requiredSelect': 'Required',
  'pages.billing.providerCodePlaceholder':
    'e.g. wanweilOT, must match the server recharge.sim_platforms config key',
  'pages.billing.editPackage': 'Edit plan',
  'pages.billing.selectProvider': 'Select provider',
  'pages.billing.packageName': 'Plan name',
  'pages.billing.platformPackageCode': 'Platform plan code (pcode/type)',
  'pages.billing.platformPackageCodePlaceholder': 'Upstream platform plan code',
  'pages.billing.useTypeFieldLabel': 'Use type field (otherwise pcode)',
  'pages.billing.userPriceYuan': 'User price (CNY)',
  'pages.billing.platformCostYuan': 'Platform cost price (CNY)',
  'pages.billing.onShelf': 'On shelf',

  'pages.billing.orderDetailTitle': 'Order details',
  'pages.billing.loading': 'Loading…',
  'pages.billing.secOrderPay': 'Order & payment',
  'pages.billing.secDevice': 'Device',
  'pages.billing.secSimCardSnapshot': 'SIM card (snapshot)',
  'pages.billing.secPackage': 'Plan',
  'pages.billing.dWechatTradeNo': 'WeChat transaction ID',
  'pages.billing.dPaidAt': 'Paid at',
  'pages.billing.dFailedReason': 'Failure reason',
  'pages.billing.dRechargeError': 'IoT recharge error',
  'pages.billing.dRefundedAt': 'Refunded at',
  'pages.billing.dQuotaTotal': 'Purchased quota',
  'pages.billing.dQuotaUsed': 'Used quota',
  'pages.billing.dRemaining': 'Remaining quota',
  'pages.billing.dDevId': 'Device ID',
  'pages.billing.dDevName': 'Device name',
  'pages.billing.dIotSCode': 'IoT number',
  'pages.billing.dPlatformOrder': 'Platform order no.',
  'pages.billing.dPkgId': 'Plan ID',
  'pages.billing.dPrice': 'Price (CNY)',
  'pages.billing.total': 'Total {count} items',

  // ===== SimRecharge (Web console) new keys =====
  'pages.simRecharge.notice.heading': 'Pre-purchase Notice',
  'pages.simRecharge.notice.sec1Title': '1. Disclaimer & Risk Notice',
  'pages.simRecharge.notice.sec1Body':
    'You understand and agree that 4G data plan top-ups depend on the device, carrier and third-party platform systems, and may be affected by network fluctuations, tariff policies, maintenance windows, card status and other factors. "{platform}" will process the top-up within a reasonable scope, but shall not be liable, beyond what laws and regulations require, for a specific arrival time, occasional discrepancies between platform display and carrier-side data, or losses caused by force majeure. Before paying, please re-check the selected <b>device & ICCID, plan name and amount</b>, and pay only after confirming.',
  'pages.simRecharge.notice.sec2Title': '2. Refund Rules',
  'pages.simRecharge.notice.sec2p1':
    '(1) <b>Top-up failure</b>: if the order is ultimately judged as failed after payment, the paid amount will be <b>refunded via WeChat Pay to the original method</b>. The actual path follows WeChat and the order status: the system may refund automatically, or you may need to <b>manually request</b> an original-route refund for the failed order in "My Orders". Please watch the order status and your WeChat bill.',
  'pages.simRecharge.notice.sec2p2':
    '(2) <b>Top-up success</b>: once the order shows the top-up is completed and the plan has been delivered or is in effect, this service is a fulfilled digital/telecom consumption and is <b>non-refundable</b>. Please choose carefully before ordering.',
  'pages.simRecharge.notice.sec3Title': '3. Others',
  'pages.simRecharge.notice.sec3Body':
    'This notice is a supplement to the User Agreement; in case of any inconsistency, the User Agreement and on-page notices shall prevail. If you have questions, please contact us through the customer-service channel published in the app.',

  'pages.simRecharge.platformDefault': 'this platform',
  'pages.simRecharge.loadPkgFail': 'Failed to load plans',
  'pages.simRecharge.deviceLabel': 'Device #{id}',
  'pages.simRecharge.prefillInvalid':
    'The device or SIM card in the link is invalid. Please select manually in the dropdown.',
  'pages.simRecharge.done': 'Top-up completed',
  'pages.simRecharge.rechargeFailed': 'Top-up failed',
  'pages.simRecharge.cancelled': 'Order cancelled',
  'pages.simRecharge.statusFallback': 'Status {st}',
  'pages.simRecharge.selectDevicePkg': 'Please select a device and a plan',
  'pages.simRecharge.orderFail': 'Failed to place order',
  'pages.simRecharge.noCodeUrl':
    'No payment code returned. Please make sure WeChat Native Pay is enabled on the server.',
  'pages.simRecharge.cancelSent': 'Tried to cancel the pending order (ignore if already paid)',
  'pages.simRecharge.loadOrdersFail': 'Failed to load orders',
  'pages.simRecharge.disabled':
    'SIM top-up or WeChat Pay is not enabled in this environment. Please contact the administrator.',
  'pages.simRecharge.scanHint':
    'Please scan the payment code with your own WeChat to complete payment; the page will refresh the result automatically after a successful payment.',
  'pages.simRecharge.prefillBanner': 'Prefilled from device management: {device}, SIM ICCID: {iccid}',
  'pages.simRecharge.tab.recharge': 'Top up',
  'pages.simRecharge.tab.orders': 'My orders',
  'pages.simRecharge.selectDeviceLabel': 'Select device (ICCID must be reported)',
  'pages.simRecharge.selectDevicePlaceholder': 'Please select a device',
  'pages.simRecharge.deviceFallback': 'Device',
  'pages.simRecharge.selectPackageLabel': 'Select plan',
  'pages.simRecharge.selectPackagePlaceholder': 'Please select a plan',
  'pages.simRecharge.selectDeviceFirst': 'Please select a device first',
  'pages.simRecharge.genPayCode': 'Generate WeChat payment code',
  'pages.simRecharge.orderStatusPending': 'Unpaid',
  'pages.simRecharge.orderStatusPaid': 'Paid',
  'pages.simRecharge.orderStatusRecharging': 'Recharging',
  'pages.simRecharge.orderStatusDone': 'Completed',
  'pages.simRecharge.orderStatusFailed': 'Top-up failed',
  'pages.simRecharge.orderStatusCancelled': 'Cancelled',
  'pages.simRecharge.filterStatus': 'Order status',
  'pages.simRecharge.filterStatusAll': 'All',
  'pages.simRecharge.filterOrderNo': 'Order no. (fuzzy)',
  'pages.simRecharge.filterQuery': 'Search',
  'pages.simRecharge.noticeModalTitle': '4G Data Top-up — Pre-purchase Notice',
  'pages.simRecharge.noticeAgree':
    'I have read and understood the notice above (including disclaimer and refund rules)',
  'pages.simRecharge.agreeAndGenPayCode': 'Agree and generate payment code',
  'pages.simRecharge.wechatScanTitle': 'WeChat QR payment',
  'pages.simRecharge.closeAndCancel': 'Close and cancel pending payment',
  'pages.simRecharge.payOrderInfo': 'Order {no}, payable ¥{amount}',
};
